import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { BaseComponent } from '../base/base.component';
import { QuoteInfo, QuotePresentationInfo } from 'src/app/models/models';
import { Currency, Store } from 'src/app/models/RestModels';
import { GetEmpty } from 'src/app/classes/Empties';
import { NumeroALetras } from 'src/app/classes/NumeroALetras';

@Component({
	selector: 'app-print-custom-quote',
	templateUrl: './print-custom-quote.component.html',
	styleUrls: ['./print-custom-quote.component.css']
})
export class PrintCustomQuoteComponent extends BaseComponent implements OnInit {
	quote_info: QuoteInfo | null = null;
	presentation_info: QuotePresentationInfo | null = null;
	store: Store = GetEmpty.store();
	currency: Currency = GetEmpty.currency();
	total_letra: string = '';

	ngOnInit(): void {
		this.sink = this.route.paramMap.pipe(
			mergeMap((params) => {
				const id = Number(params.get('id'));
				return forkJoin({
					quote_info: this.rest.quote_info.get(id),
					presentation_info: this.rest.getQuotePresentationInfo(id),
					stores: this.rest.getStores(),
					currencies: this.rest.currency.search({limit:999})
				});
			})
		).subscribe((responses) => {
			this.quote_info = responses.quote_info;
			this.presentation_info = responses.presentation_info;

			if (this.presentation_info && this.presentation_info.sections) {
				this.presentation_info.sections.sort((a, b) => {
					const orderA = Number((a.section as any).sort_order) || 0;
					const orderB = Number((b.section as any).sort_order) || 0;
					return orderB - orderA;
				});
			}

			if (this.quote_info && this.quote_info.quote) {
				this.store = responses.stores.data.find(s => s.id == this.quote_info.quote.store_id) || GetEmpty.store();
				this.currency = responses.currencies.data.find(c => c.id == this.quote_info.quote.currency_id) || GetEmpty.currency();

				const n = new NumeroALetras('', '', '/100', '/100');
				this.total_letra = n.numeroALetras(this.quote_info.quote.total);

				// Auto print after load
				setTimeout(() => {
					window.print();
				}, 1000);
			}
		}, (error) => this.showError(error));
	}

	getPrimaryVisuals() {
		return this.presentation_info?.images.filter(img => img.type === 'PRIMARY_VISUAL') || [];
	}

	getSupportingDetails() {
		return this.presentation_info?.images.filter(img => img.type === 'SUPPORTING_DETAIL' || img.type === 'REFERENCE') || [];
	}

	getSectionTotal(sectionId: number) {
		const section = this.presentation_info?.sections.find(s => s.section.id === sectionId);
		if (!section) return 0;
		return section.links.reduce((sum, link) => {
			const item = this.quote_info?.items.find(i => i.quote_item.id === link.quote_item_id);
			return sum + (item ? item.quote_item.total : 0);
		}, 0);
	}

	getPurchaseTotal() {
		return this.quote_info?.items.reduce((sum, item) => sum + (item.quote_item.total || 0), 0) || 0;
	}
}
